import { render, staticRenderFns } from "./BaseCatchingBulkCreate.vue?vue&type=template&id=278b6ce8&scoped=true&"
import script from "./BaseCatchingBulkCreate.vue?vue&type=script&lang=js&"
export * from "./BaseCatchingBulkCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278b6ce8",
  null
  
)

export default component.exports